module.exports = __webpack_public_path__ + "static/media/covid.b1ad7500.mp3";